import type { Ref, ComputedRef } from 'vue'

function isReactiveNumber(value: number | Ref<number>): value is Ref<number> {
  return typeof value === 'object'
}

import { watch } from 'vue'

/**
 * A Vue composable that sets a CSS variable to a value.
 * @param key - The CSS variable key to set.
 * @param value - The value to set the CSS variable to.
 * @param element - The element to set the CSS variable on. Defaults to document.
 * @param unit - The unit to set the CSS variable to. Defaults to px.
 */
export default function useSetCSSVariable(
  key: string,
  value: number | Ref<number> | ComputedRef<number>,
  element: HTMLElement | undefined = document.documentElement,
  unit = 'px'
): void {
  if (!isReactiveNumber(value)) {
    element.style.setProperty(key, `${value}${unit}`)
  } else {
    watch(
      value,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          element.style.setProperty(key, `${newValue}${unit}`)
        }
      },
      {
        immediate: true,
      }
    )
  }
}
